<template>
    <div class="ec-bike-listing-sorting-button col-xs-7 col-sm-4 col-sm-offset-4 col-md-3 col-md-offset-6 col-lg-3 col-lg-offset-7">
        <div class="ec-bike-listing-sorting-button-inner-wrapper" @click.stop="onClick">
            Classer par: {{ currentSortBy }}
            <i class="glyphicon glyphicon-chevron-down pull-right" v-if="!sortingMenuOpen"></i>
            <i class="glyphicon glyphicon-chevron-up pull-right" v-if="sortingMenuOpen"></i>
        </div>

        <div class="ec-bike-listing-sorting-box" v-if="sortingMenuOpen">
            <ul>
                <li v-for="option in $store.state.sortingButton.sortByOptions">
                    <a :href="option.url" :class="{ active: option.label === $store.state.sortingButton.sortBy }"
                       @click="currentSortBy = option.label">{{ option.label }}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<style lang="scss" type="text/scss">
    @import "../../../sass/variables";
    @import "../../../sass/mixins";

    .ec-bike-listing-sorting-button {
        @include ec-bike-listing-button();

        position: relative;
        font-size: $ec-font-size-small;
        padding-right: $ec-bike-listing-controls-padding;

        .ec-bike-listing-sorting-button-inner-wrapper {
            color: $text-muted;
            text-align: right;
            line-height: 20px;
            position: relative;
            padding-right: $grid-gutter-width;
            @include ellipsis();

            .glyphicon {
                position: absolute;
                right: 0;
            }
        }

        .ec-bike-listing-sorting-box {
            position: absolute;
            background: $ec-bike-info-background;
            padding: 0 $grid-gutter-width/2;
            right: 0;
            top: $ec-bike-listing-controls-height;
            margin-right: $ec-bike-listing-controls-padding;
            z-index: 1;
            @include box-shadow(1px 1px 5px $ec-control-focus-border-color);

            @media (max-width: $screen-xs-max) {
                margin-right: $ec-bike-listing-controls-padding-xs;
            }

            ul, li {
                margin: 0;
                padding: 0;
                list-style: none;
            }

            li {
                a, a:active, a:hover, a:focus {
                    color: $text-color;
                    display: block;
                    height: 32px;
                    line-height: 32px;
                    padding: 0 $grid-gutter-width;
                    margin: $grid-gutter-width/6 (-$grid-gutter-width/2);
                    text-decoration: none;
                    @include ellipsis();

                    @include transition(color 0.15s ease, background 0.2s ease);
                }

                a:hover, a:active, a.active {
                    background: $ec-primary-color;
                    color: $ec-color-white;
                }
            }
        }

        @media (max-width: $screen-xs-max) {
            padding-right: $ec-bike-listing-controls-padding-xs;
        }
    }


</style>

<script type="text/babel">
    const GA = require('../../modules/ga');

    export default {
        data: function () {
            return {
                sortingMenuOpen: false,
                currentSortBy: '...'
            };
        },

        computed: {},

        mounted: function () {
            this.currentSortBy = this.$store.state.sortingButton.sortBy;

            $('body').on('click', () => {
                if (!this.sortingMenuOpen) {
                    return;
                }

                this.sortingMenuOpen = false;

                GA.event('sorting', 'open', 'Toggle bike listing sorting menu');
            })
        },

        watch: {},

        methods: {
            onClick: function (ev) {
                this.sortingMenuOpen = !this.sortingMenuOpen;

                GA.event('sorting', this.sortingMenuOpen ? 'open' : 'close', 'Toggle bike listing sorting menu');
            }
        }
    }
</script>